import React, { useMemo, useEffect, useState } from "react";
import { Grid, TextField, Button, Box, Select, MenuItem } from "@mui/material";
import dayjs from "dayjs";

const FilterComponent = ({
  filters,
  setFilters,
  data,
  Local_EmployeePhone,
  applyFilters,
  setFilterShow,
}) => {
  const today = dayjs().startOf("day");

  // Predefined date ranges
  const predefinedRanges = [
    { label: "Today", startDate: today, endDate: today },
    {
      label: "Yesterday",
      startDate: today.subtract(1, "day"),
      endDate: today.subtract(1, "day"),
    },
    {
      label: "Last 7 Days",
      startDate: today.subtract(6, "day"),
      endDate: today,
    },
    {
      label: "Last Month",
      startDate: today.subtract(1, "month").startOf("month"),
      endDate: today.subtract(1, "month").endOf("month"),
    },
    { label: "Custom", startDate: null, endDate: null },
  ];

  const [filtersData, setFiltersData] = useState({
    selectedRange: predefinedRanges[2], // Default to "Last 7 Days"
    customStartDate: predefinedRanges[2].startDate,
    customEndDate: predefinedRanges[2].endDate,
  });

  // // Keep agentNumber in sync from props
  // useEffect(() => {
  //   setFiltersData((prev) => ({
  //     ...prev,
  //     agentNumber: Local_EmployeePhone,
  //   }));
  // }, [Local_EmployeePhone]);

  useEffect(() => {
    const savedFilters = localStorage.getItem("agentFilters");
    if (savedFilters) {
      const filters = JSON.parse(savedFilters);

      if (filters.startDate && filters.endDate) {
        filters.customStartDate = dayjs(filters.startDate);
        filters.customEndDate = dayjs(filters.endDate);
      } else {
        filters.customStartDate = dayjs().subtract(7, "days");
        filters.customEndDate = dayjs();
      }

      const matchedRange = predefinedRanges.find(
        (range) =>
          range.startDate &&
          range.endDate &&
          range.startDate.isSame(filters.customStartDate, "day") &&
          range.endDate.isSame(filters.customEndDate, "day")
      );

      setFiltersData({
        ...filters,
        selectedRange: matchedRange || predefinedRanges.find((r) => r.label === "Custom"),
      });
    }
  }, []);

  const handleInputChange = (key, value) => {
    setFiltersData((prevFilters) => {
      const updatedFilters = { ...prevFilters, [key]: value };
      if (key === "selectedRange" && value.label !== "Custom") {
        updatedFilters.customStartDate = value.startDate;
        updatedFilters.customEndDate = value.endDate;
      }
      return updatedFilters;
    });
  };

  const handleCustomDateChange = (key, value) => {
    setFiltersData((prevFilters) => ({
      ...prevFilters,
      [key]: dayjs(value),
    }));
  };

  const handleApply = () => {
    const { selectedRange, customStartDate, customEndDate, agentNumber } = filtersData;

    const startDate =
      selectedRange.label === "Custom"
        ? customStartDate?.isValid()
          ? customStartDate.format("YYYY-MM-DD")
          : null
        : selectedRange.startDate?.format("YYYY-MM-DD") ?? null;

    const endDate =
      selectedRange.label === "Custom"
        ? customEndDate?.isValid()
          ? customEndDate.format("YYYY-MM-DD")
          : null
        : selectedRange.endDate?.format("YYYY-MM-DD") ?? null;

    setFilters({
      startDate,
      endDate,
      agentNumber,
    });

    localStorage.setItem(
      "agentFilters",
      JSON.stringify({ startDate, endDate, agentNumber })
    );

  };

  const handleClear = () => {
    const defaultRange = predefinedRanges[2]; // "Last 7 Days"
    const startDate = defaultRange.startDate.format("YYYY-MM-DD");
    const endDate = defaultRange.endDate.format("YYYY-MM-DD");
    const agentNumber = "";

    setFilters({
      startDate,
      endDate,
      agentNumber
    });

    setFiltersData({
      selectedRange: defaultRange,
      customStartDate: defaultRange.startDate,
      customEndDate: defaultRange.endDate,
      agentNumber:"",
    });

    localStorage.removeItem("agentFilters");
  };

  return (
    <Box
      sx={{
        backgroundColor: "#f0f4f8",
        padding: 1,
        borderRadius: 2,
        boxShadow: 3,
        width: "100%",
      }}
    >
      <Grid container spacing={2}>
        {/* Predefined Ranges */}
        <Grid item xs={12} sm={2}>
          <Select
            value={filtersData.selectedRange.label}
            onChange={(e) =>
              handleInputChange(
                "selectedRange",
                predefinedRanges.find((range) => range.label === e.target.value)
              )
            }
            fullWidth
            size="small"
          >
            {predefinedRanges.map((range) => (
              <MenuItem key={range.label} value={range.label}>
                {range.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        {/* Date Pickers */}
        <Grid item xs={12} sm={2}>
          <TextField
            label="Start Date"
            type="date"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            value={
              filtersData.customStartDate
                ? filtersData.customStartDate.format("YYYY-MM-DD")
                : ""
            }
            onChange={(e) => handleCustomDateChange("customStartDate", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            label="End Date"
            type="date"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            value={
              filtersData.customEndDate
                ? filtersData.customEndDate.format("YYYY-MM-DD")
                : ""
            }
            onChange={(e) => handleCustomDateChange("customEndDate", e.target.value)}
          />
        </Grid>

        {/* Action Buttons */}
        <Grid item xs={12} sm={3}>
          <Box sx={{ display: "flex" }}>
            <Button
              onClick={handleClear}
              variant="outlined"
              color="secondary"
              sx={{ marginRight: 2 }}
            >
              Clear
            </Button>
            <Button onClick={handleApply} variant="contained" color="primary">
              Apply
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );

};

export default FilterComponent;
